import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Timeline, TimelineLite, TimelineMax} from "gsap";
import {WinterHoardParsedGameData} from "../server/data/IWinterHoardServerData";
import {WinterHoardGameModuleConfig} from "../WinterHoardGameModuleConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {WinterHoardReelSymbol} from "../symbols/WinterHoardReelSymbol";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {StateMatrix} from "../utils/StateMatrix";
import {SymbolUtil} from "../utils/SymbolUtil";
export class IdleNormal implements GameRoundPresentation {

    private _tl:Timeline;
    private _gameData:ParsedGameData;
    private _symbolStates:StateMatrix<string>;
    private _playedNoWin:boolean = false;

    constructor(){}

    getAnimation(data: WinterHoardParsedGameData): Timeline {
        if(this._tl) {
            this._tl.pause();
            this._tl.kill();
        }
        const tl:TimelineMax = new TimelineMax({repeat: -1});
        if (!(data instanceof ParsedGameData) || data.betWins == undefined || data.betWins.length <= 0) {
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SET_ENABLED, true));
            tl.add(() => {
                WinterHoardGameModuleConfig.logoView.playLogoIdle();
                const symTl:TimelineLite = new TimelineLite();
                [0,1,2,3,4].forEach((rID) => {
                    symTl.add(() => {
                        [0,1,2,3].forEach((sID) => {
                            const symbol:WinterHoardReelSymbol | null =  <WinterHoardReelSymbol> Reels.getSymbol(rID,sID);
                            if(symbol) {
                                if(symbol.symName === "W"){
                                    symbol.changeState({state:GameConfig.instance.SYMBOL_STATES.idle!})
                                }else{
                                    symbol.playIdleSpine();
                                }
                            }
                        });
                    }, "+=0.3")

                })
            }, "+=8");

            this._tl = tl;
            return tl;
        }
        EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SET_ENABLED, false));
        const stagger: string = "+=" + (data.betWins.length * 0.5).toString();
        const betlineTl: TimelineLite = new TimelineLite();
        for (let i: number = 0; i < data.betWins.length; i++) {
            betlineTl.add(WinterHoardGameModuleConfig.animatedWinLines.playAnimatedWinline(
                (<IBetLineWinData>data.betWins[i]).betLineIndex,
                (<IBetLineWinData>data.betWins[i]).amount.toString())
            );
        }

        tl.add([
            betlineTl,
            (!this._playedNoWin)? this.getNoWinSymbolAnimations() : () => {}
        ], 1);
        this._tl = tl;
        return tl;
    }

    private getSymbolAnimation(reelId:number, symbolId:number, state:ISymbolStateConfig):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        const symbol:StateReelSymbol | null = Reels.getSymbol(reelId, symbolId);
        if(symbol) {
            const symbolAnimation:Timeline = symbol.changeState({
                state : state,
                //setStack : true,
                fadeInDuration : 0.0
            })!;

            tl.add([
                //() => this.sortSymbolDepthToTop(symbol),
                symbolAnimation
            ]);
        }
        return tl;
    }

    public getNoWinSymbolAnimations():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        if(!this._symbolStates) {
            return new TimelineLite();
        }

        this._playedNoWin = true;
        //console.log("PLAYED NO WIN");
        //tl.add(() => {}, 0.1);
        if(this._gameData!.mode === GameMode.NORMAL) {
            for (let reelId = 0; reelId < 5; reelId++) {
                const reelCoords: [number, number][] = this._symbolStates.getCoordinatesWithStateInReel(reelId, GameConfig.instance.SYMBOL_STATES.noWin!.keyword);
                for (let coords of reelCoords) {
                    if(!(this._gameData!.nextMode.indexOf("FREESPIN") > -1 && Reels.getSymbol(coords[0], coords[1])!.symName === "S")){
                        tl.add(this.getSymbolAnimation(coords[0], coords[1], GameConfig.instance.SYMBOL_STATES.noWin!), 0.1);
                    }
                }

                tl.add(this.getSymbolAnimation(reelId, -1, GameConfig.instance.SYMBOL_STATES.noWin!), 0.1);
                tl.add(this.getSymbolAnimation(reelId, 4, GameConfig.instance.SYMBOL_STATES.noWin!), 0.1);
            }
        }


        return tl;
    }

    prepare(data:ParsedServerData): void {
        this._playedNoWin = false;
        this._gameData = <ParsedGameData>data;
        if(this._gameData.betWins) {
            this._symbolStates = SymbolUtil.createSymbolStateMatrixFromBetWins(
                <IBetLineWinData[]>this._gameData.betWins!,
                GameConfig.instance.SYMBOL_STATES.noWin!.keyword,
                GameConfig.instance.SYMBOL_STATES.win!.keyword);
        }
    }

    public abort(isActive:boolean, data:SpinParsedGameData):Timeline | null {
        EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SET_ENABLED, false));
        return null;
    }
}